import { dispatchPromise } from './action-helpers';

export const fetchAuthDetails = () => {
    return dispatchPromise({
        type: 'AUTH_DETAILS_FETCH_REQUESTED'
    });
}

export const setTeamUrl = teamUrl => {
    return dispatchPromise({
        type: 'TEAM_URL_SET_REQUESTED',
        payload: { teamUrl }
    });
}

export const setAuthDetails = authDetails => {
    return dispatchPromise({
        type: 'AUTH_DETAILS_SET_REQUESTED',
        payload: authDetails
    });
}

export const setMasterToken = masterToken => {
    return dispatchPromise({
        type: 'MASTER_TOKEN_SET_REQUESTED',
        payload: { masterToken }
    });
}

export const setTeamToken = (teamUrl, teamToken) => {
    return dispatchPromise({
        type: 'TEAM_TOKEN_SET_REQUESTED',
        payload: { teamUrl, teamToken }
    });
}

export const removeTeamToken = teamUrl => {
    return dispatchPromise({
        type: 'TEAM_TOKEN_REMOVE_REQUESTED',
        payload: { teamUrl }
    });
}

export const setSigningUp = () => {
    return dispatchPromise({
        type: 'SIGNING_UP'
    });
}

export const setSignedUp = () => {
    return dispatchPromise({
        type: 'SIGNED_UP'
    });
}
